export const PERMISSIONS = {
  INSIGHTS: "AISTUDIOINSIGHTS",
  ASSISTENTES: "AISTUDIOASSISTENTES",
  GERACAO_CONTEUDO: "AISTUDIOGERACAOCONTEUDO",
  MONITORAMENTO_USO: "AISTUDIOMONITORAMENTODEUSO",
};
